import { render, staticRenderFns } from "./UserProfileNav.vue?vue&type=template&id=071c2d5f&scoped=true&"
var script = {}
import style0 from "./UserProfileNav.vue?vue&type=style&index=0&id=071c2d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c2d5f",
  null
  
)

export default component.exports